import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';

function WelcomeFreeSpinsPromo(props: any) {
    const {
        app: { brandId },
        theme,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function getDomain(brandId: any) {
        if ([31, 32, 61, 35, 36].includes(brandId)) return "Yolo247";
        if ([37, 39, 40].includes(brandId)) return "Fomo7";
        if ([46, 47, 49].includes(brandId)) return "Fun88";
        return "Iw247";
    }
    const domainName = getDomain(brandId);
    const isPK = brandId && (brandId == 35 || brandId == 36 || brandId == 37 || brandId == 49);
    const totalCashbackAmount = (brandId == 61) ? "$0.01" : isPK ? "PKR 3" : "₹1";

    return (
        <>
            <InformationWrapper>
                <h1>50 free spins on Chicken Road 2 Bonus</h1>
                <p className="top-para">Kickstart your welcome journey with 50 Free Spins on <strong>'Chicken Road 2 Bonus'</strong> across your first 3 deposits</p>

                <h2>Free Spins Structure</h2>
                <Table>
                    <thead>
                        <tr>
                            <th>Deposit</th>
                            <th>Free Spins</th>
                            <th>Time Frame</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1st deposit</td>
                            <td>10 fS</td>
                            <td>Anytime</td>
                        </tr>
                        <tr>
                            <td>2nd deposit</td>
                            <td>15 fS</td>
                            <td>Anytime</td>
                        </tr>
                        <tr>
                            <td>3rd deposit</td>
                            <td>25 fS</td>
                            <td>Anytime</td>
                        </tr>
                    </tbody>
                </Table>

                <h2>How to Claim Free Spins</h2>
                <ImageWrapper>
                    <LazyLoadImage
                        src={`${config.imageV3Host}/static/cashsite/${theme.image.WelcomeFreeSpinsBonusDepositImage}`}
                        effect="none"
                        placeholder={<PlaceholderImage />}
                    />
                </ImageWrapper>

                <h2>Terms & Conditions</h2>
                <TermsList>
                    <li>Spin Value: {totalCashbackAmount}.</li>
                    <li>Free Spins Valid For First 3 Deposits Only.</li>
                    <li>Free Spins Must Be Used Within 72 Hours Of Being Credited.</li>
                    <li>Cannot Be Combined With Welcome Bonus Or Other Free Spin Promotions.</li>
                    <li>Multiple Accounts, Collusion, Or Foul Play Disqualifies Participants.</li>
                    <li>Void, Canceled, Drawn, Or Cashed-Out Bets Do Not Count.</li>
                    <li>Promotion Subject To Brand Discretion; Brands Reserve The Right To Amend, Cancel, Reclaim, Or Refuse Participation.</li>
                    <li>General Terms & Conditions Of The Respective Brand Apply.</li>
                </TermsList>
            </InformationWrapper>

        </>
    );
}

export default withTheme(withAppContext(WelcomeFreeSpinsPromo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 2rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.WelcomeFreeSpinsBonusBackground")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    position: relative;
    gap: 2rem;

    h1, h2, p {
        margin: 0;
        padding: 0;
    }

    h1, h2 {
        width: 100%;
        color: #FFD72D;
        text-align: center;
        font-style: normal;
        font-weight: 700;
        font-family: 'Inter-Bold';
        line-height: normal;
    }

    h1 {
        font-size: 22px;
        text-transform: uppercase;
    }

    h2 {
        font-size: 20px;
        text-transform: capitalize;
    }

    .top-para {
        width: 100%;
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 35px;
        text-transform: capitalize;
    }
`;

const Table = styled.table`
    width: 60%;
    border-collapse: separate;
    border-spacing: 0 10px;
    table-layout: fixed;
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    line-height: 35px;
    text-transform: capitalize;
    margin: 0 auto;

    td {
        padding: 1rem;
    }

    thead tr th {
        font-weight: 400;
    }

    tbody tr {
        background: #734F09;
    }

    tbody tr td {
        font-weight: 600;
    }

    tbody tr td:first-child {
        border-radius: 5px 0 0 5px;
    }
    tbody tr td:last-child {
        border-radius: 0 5px 5px 0;
    }
`;

const ImageWrapper = styled.div`
    width: 65%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(7px);
    
    img {
        width: 100%;
    }
`;

const TermsList = styled.ul`
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    margin: 0 auto;
    padding: 0;
    list-style: none;

    li {
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        text-align: left;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        background: #3A3A3A;
        padding: 12px 1.5rem 12px 2.5rem;
        position: relative;
    }

    li::before {
        content: "✦";
        position: absolute;
        color: #fff;
        left: 1.5rem;
        top: 12px;
    }
`;